<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
  font-weight: 400;
  color: #424242;">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;
      Manage Conveyance Rate</h5>
  </div>
  <div id="mainContent" class="container">
    <div class="row pt-2">
      <div class="col-md-3" style="padding-left:30px;">
        <label>Branch :</label>
        <select class="form-control form-control-xs" id="branch" name="branch" type="text"
          class="form-control form-control-xs" [(ngModel)]="branch" (change)="onChangeBranch()"
          matTooltipPosition="above">
          <option [value]="null">Select</option>
          <option *ngFor="let branch of branchList" [ngValue]="branch">{{ branch.name }}</option>
        </select>
      </div>
      <div class="col-md-6 offset-md-2" style="padding-top: 15px;">
        <button id="addConveyanceBtn" name="addConveyanceBtn" mat-raised-button class="btn-theme" style="float:right"
          matTooltip="Click to add" matTooltipPosition="left" (click)="openModal(modalContent,'add')">
          <i class="fa fa-plus-square" aria-hidden="true"></i>&nbsp;&nbsp; Conveyance Rate
        </button>
      </div>
    </div>

    <div class="pt-2 pb-2">
      <div class="col-md-12">
        <table class="table table-bordered table-striped table-sm">
          <thead class="">
            <tr>
              <th scope="col">Sr.No.</th>
              <th scope="col">Role</th>
              <th scope="col">Two Wheeler Rate</th>
              <th scope="col">Four Wheeler Rate</th>
              <th scope="col">Four Wheeler NonChargable Rate</th>
              <th scope="col">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let modalFormObj of modalFormObjList; index as i" id="conveyance_{{i}}">
              <td scope="row">{{i+1}}</td>
              <td>{{modalFormObj.role.name}}</td>
              <td>{{modalFormObj.twoWheelerRate}}</td>
              <td>{{modalFormObj.fourWheelerRate}}</td>
              <td>{{modalFormObj.fourWheelerNonChargableRate}}</td>
              <td>
                <button id="editConveyanceBtn_{{i}}" name="editConveyanceBtn_{{i}}" class="btn btn-sm btn-outline-theme"
                  (click)="onEditClick(modalContent,modalFormObj)" matTooltip="Click to edit"
                  matTooltipPosition="above">
                  <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                </button> &nbsp;&nbsp;
                <button id="deleteConveyanceBtn_{{i}}" name="deleteConveyanceBtn_{{i}}"
                  class="btn btn-sm btn-outline-danger" (click)="onDeleteClick(modalFormObj)"
                  matTooltip="Click to delete" matTooltipPosition="above">
                  <i class="fa fa-trash-o" aria-hidden="true"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
<!-- Modal Template -->
<ng-template #modalContent let-modal>
  <div class="modal-header bg-theme bg-theme-txt pt-2 pb-2">
    <h5 class="modal-title" id="modal-basic-title">Conveyance Rate</h5>
  </div>
  <div class="modal-body">
    <form [formGroup]="modalForm">
      <div class="row">
        <label class="col-sm-6">Effective Date :</label>
        <div class="col-sm-6">
          <div class="input-group">
            <input class="form-control form-control-xs" placeholder="dd/mm/yyyy" name="effectiveDate" ngbDatepicker
              #effectiveDate="ngbDatepicker" formControlName="effectiveDate" [placement]="'bottom'"
              [class.is-invalid]="formErrors.effectiveDate && formSubmitted" matTooltip="{{formErrors.effectiveDate}}"
              matTooltipPosition="above" matTooltipClass="warn-tooltip">
            <div class="input-group-append">
              <button class="btn btn-outline-theme calendar" (click)="effectiveDate.toggle()" type="button"></button>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <label class="col-sm-6">Role :</label>
        <div class="col-sm-6">
          <select class="form-control form-control-xs" id="role" name="role" type="text" 
            class="form-control form-control-xs" formControlName="role" [compareWith]="compareById"
            [class.is-invalid]="formErrors.role && formSubmitted" matTooltip="{{formErrors.role}}"
            matTooltipPosition="above">
            <option [ngValue]="null">Select</option>
            <option *ngFor="let role of roleList" [ngValue]="role">{{ role.name }}</option>
          </select>
        </div>
      </div>

      <div class="row">
        <label class="col-sm-6">Conveyance Allow:</label>
        <div class="col-sm-6">
          <div class="form-check form-check-inline">
            <mat-checkbox [color]="'primary'" id="allowTwoWheeler" name="allowTwoWheeler"
              formControlName='allowTwoWheeler'>Two Wheeler</mat-checkbox>
          </div>
          <mat-checkbox [color]="'primary'" id="allowFourWheeler" name="allowFourWheeler"
            formControlName='allowFourWheeler'>Four Wheeler</mat-checkbox>

        </div>
      </div>
      <div *ngIf="modalForm.get('allowTwoWheeler').value" class="animate__animated animate__fadeInDown">
        <div class="row">
          <label class="col-sm-6">Conveyance Rate Two Wheeler:</label>
          <div class="col-sm-6">
            <input id="twoWheelerRate" name="twoWheelerRate" type="number" class="form-control form-control-xs"
              formControlName="twoWheelerRate" [class.is-invalid]="formErrors.twoWheelerRate && formSubmitted"
              matTooltip="{{formErrors.twoWheelerRate}}" matTooltipPosition="above" matTooltipClass="warn-tooltip"
              (input)="limitDecimal($event)">

            <div class="validation-error" *ngIf="modalForm.get('twoWheelerRate').hasError('pattern')
              && modalForm.get('twoWheelerRate').touched">
              Invalid input.
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="modalForm.get('allowFourWheeler').value" class="animate__animated animate__fadeInDown">
        <div class="row">
          <label class="col-sm-6">Conveyance Rate Four Wheeler:</label>
          <div class="col-sm-6">
            <input id="fourWheelerRate" name="fourWheelerRate" type="number" class="form-control form-control-xs"
              formControlName="fourWheelerRate" [class.is-invalid]="formErrors.fourWheelerRate && formSubmitted"
              matTooltip="{{formErrors.fourWheelerRate}}" matTooltipPosition="above" matTooltipClass="warn-tooltip"
              (input)="limitDecimal($event)">

            <div class="validation-error" *ngIf="modalForm.get('fourWheelerRate').hasError('pattern')
              && modalForm.get('fourWheelerRate').touched">
              Invalid input.
            </div>
          </div>
        </div>

        <div class="row">
          <label class="col-sm-6">Conveyance Rate Four Wheeler NonChargable):</label>
          <div class="col-sm-6">
            <input id="fourWheelerNonChargableRate" name="fourWheelerNonChargableRate" type="number"
              class="form-control form-control-xs" formControlName="fourWheelerNonChargableRate"
              [class.is-invalid]="formErrors.fourWheelerNonChargableRate && formSubmitted"
              matTooltip="{{formErrors.fourWheelerNonChargableRate}}" matTooltipPosition="above"
              matTooltipClass="warn-tooltip" (input)="limitDecimal($event)">

            <div class="validation-error" *ngIf="modalForm.get('fourWheelerNonChargableRate').hasError('pattern')
              && modalForm.get('fourWheelerNonChargableRate').touched">
              Invalid input.
            </div>
          </div>
        </div>
      </div>

    </form>
  </div>
  <div class="modal-footer">
    <div class="row col-md-12">
      <div class="col-sm-6"></div>
      <div class="col-sm-3">
        <button id="closeConveyanceBtn" name="closeConveyanceBtn" type="button"
          class="btn btn-sm btn-block btn-outline-secondary" (click)="modal.dismiss('Cross click')">Close</button>
      </div>
      <div class="col-sm-3">
        <button id="saveConveyanceBtn" name="saveConveyanceBtn" type="button" *ngIf="modalStatus=='add'"
          class="btn btn-sm btn-block btn-outline-theme" (click)="onSaveClick()">Save</button>
        <button id="updateConveyanceBtn" name="updateConveyanceBtn" type="button" *ngIf="modalStatus=='edit'"
          class="btn btn-sm btn-block btn-outline-theme" (click)="onUpdateClick()">Update</button>
      </div>
    </div>
  </div>
</ng-template>